export default theme => ({
  card: {
    paddingTop: 10,
    position: 'relative',
    overflow: 'visible',
    opacity: 1,
    cursor: 'grab',
    [theme.breakpoints.only('xl')]: {
      width: 237,
    },
  },
  itemDragging: {
    opacity: 0.6
  },
  colorLine: {
    position: 'absolute',
    top: '-1px',
    left: '-1px',
    width: 'calc(100% + 2px)',
    height: 6,
    borderRadius: '5px 5px 0 0'
  },
  regularFontWeight: {
    fontWeight: 300,
  },
  paddingBox: {
    padding: '0 8px 8px',
  },
  paddingTop: {
    paddingTop: 8
  },
  paddingBottom: {
    paddingBottom: 8
  },
  paddingBottomSmall: {
    paddingBottom: 4
  },
  inlineFlex: {
    display: 'inline-flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%'
  },
  flexHeader: {
    alignItems: 'flex-start'
  },
  fixedWidth: {
    width: 'calc(100% - 30px)'
  },
  borderTop: {
    borderTop: `1px solid ${theme.palette.borderColor.primary}`,
  },
  boxBody: {
    display: 'flex',
  },
  caretbefore: {
    '&::before': {
      content: '""',
      position: 'absolute',
      left: -1,
      top: 0,
      bottom: 0,
      width: 0,
      borderWidth: 1,
      borderStyle: 'solid',
      borderColor: '#6588e8',
      borderRadius: 1,
    }
  },
  caretafter: {
    '&::after': {
      content: '""',
      position: 'absolute',
      right: -1,
      top: 0,
      bottom: 0,
      width: 0,
      borderWidth: 1,
      borderStyle: 'solid',
      borderColor: '#6588e8',
      borderRadius: 1,
    }
  }
});
